import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TipProblemaServiciiActive, TipProblemaServiciiActiveUpdate } from './tip-problema-servicii.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TipProblemaServiciiService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getTipuriProblemaServiciiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.getTipuriProblemaServiciiActive;
    private storeTipProblemaServiciiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.storeTipProblemaServiciiActive;
    private updateTipProblemaServiciiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.updateTipProblemaServiciiActive;
    private deleteTipProblemaServiciiActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.deleteTipProblemaServiciiActive;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.changeStatusTipProblemaServiciiActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.changeStatusTipProblemaServiciiPublic;
    private moveUpUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.moveUp;
    private moveDownUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.tipProblemaServiciiActive.moveDown;

    constructor(private http: HttpClient) { }

    addTipProblemaServiciiActive(modulLocatie: TipProblemaServiciiActive) {
        return this.http.post(this.storeTipProblemaServiciiActiveUrl, modulLocatie, this.httpOptions);
    }

    updateTipProblemaServiciiActive(modulLocatie: TipProblemaServiciiActiveUpdate) {
        return this.http.put(this.updateTipProblemaServiciiActiveUrl, modulLocatie, this.httpOptions);
    }

    deleteTipProblemaServiciiActive(id: number) {
        return this.http.delete(this.deleteTipProblemaServiciiActiveUrl + id);
    }

    moveUp(id: number) {
        return this.http.put(this.moveUpUrl + id, this.httpOptions);
    }

    moveDown(id: number) {
        return this.http.put(this.moveDownUrl + id, this.httpOptions);
    }

    getTipuriProblemaServiciiActive() {
        return this.http.get(this.getTipuriProblemaServiciiActiveUrl, this.httpOptions).pipe(
            map((response: any) => response.data),
            catchError((error) => {
                console.error('Error in get tipuri problema servicii active:', error);
                return throwError(error);
            })
        );
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
